import domains from '../../common/constants/domains';

export default {
  local: 'dev-mysimplestore.com',
  development: 'dev-mysimplestore.com',
  test: `mysimplestore.${domains.test}.com`,
  production: 'mysimplestore.com'
};
